import { BaseControl } from "../base-control";

class PhoneControlCtrl extends BaseControl {
  defaultPattern = '^(\\+?\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.\\-]?\\d{3}[\\s.\\-]?\\d{4}(\\sx\\d+)?$';
  validationPattern;
  constructor(BaseControlService, $scope) {
    'ngInject';
    super(BaseControlService, $scope);
  }
  
  async initializeControlData() {
    await super.initializeControlData();
    this.validationPattern = this.fieldSchema.validationPattern || this.defaultPattern;
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/phone-control/phone-control.component.html",
  controller: PhoneControlCtrl
};